import React from 'react'

const ToolbarActions = ({ children }) => (
  <div className="d-flex order-action-buttons-padding">
    {children}
  </div>
)

export default ToolbarActions
